export enum TemplateVariableType {
  /**
   * 文本变量
   */
  TEXT = 0,

  /**
   * 表格变量
   */
  TABLE = 1
}

export const TemplateVariableTypeTextMap = {
  [TemplateVariableType.TEXT]: '普通文本',
  [TemplateVariableType.TABLE]: '表格对象'
}

export const TemplateVariableTypeColorMap = {
  [TemplateVariableType.TEXT]: 'green',
  [TemplateVariableType.TABLE]: 'gold'
}
